import { Controller } from './controller-types.js';
import { newSet } from './sets.js';

export const allControllers = /*@__PURE__*/ newSet<Controller>();
